import Stats from "./Stats";
import TasksChart from "./TasksChart";
import RecourcesChart from "./RecourcesChart";
import MyTasks from "./MyTasks";
import MyProjects from "./MyProjects";
import { useAuth } from "../../context/AuthContext";

function Dashboard() {
  const { currentUser } = useAuth();

  return (
    <div className="flex flex-col gap-4 h-[92vh] overflow-y-auto scrollbar-none">
      <Stats userId={currentUser.uid} />
      <div className="flex flex-row gap-4 w-full">
        <TasksChart />
        <RecourcesChart />
      </div>
      <div className="flex flex-row gap-4 w-full">
        <MyTasks userId={currentUser.uid} />
        <MyProjects userId={currentUser.uid} />
      </div>
    </div>
  );
}

export default Dashboard;
